<template>
  <el-card>
    <el-row type="flex" justify="space-between" ref="barparent">
      <div class="flex_wrap">
        <div class="flex_box_center">
          <span>开始日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.startTime" :picker-options="pickerOptionsStart" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" style="width:68%">
          </el-date-picker>
        </div>

        <div class="flex_box_center">
          &nbsp;&nbsp;<span>结束日期&nbsp;&nbsp;</span>
          <el-date-picker v-model="query.endTime" :picker-options="pickerOptionsEnd" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" style="width:68%">
          </el-date-picker>
        </div>

        <div class="flex_box_center" v-if="isDay">
          &nbsp;&nbsp;<span>班次&nbsp;&nbsp;</span>
          <el-select clearable v-model="query.shiftCode" style="width:68%;" @change="handleShift">
            <el-option :value="undefined" label="所有"></el-option>
            <el-option value="1" label="早班"></el-option>
            <el-option value="2" label="中班"></el-option>
            <el-option value="3" label="晚班"></el-option>
            <el-option value="4" label="夜班"></el-option>
          </el-select>
        </div>

        <div class="flex_box_center" v-if="isDay">
          &nbsp;&nbsp;<span>工号&nbsp;&nbsp;</span>
          <el-select clearable v-model="query.userId"  style="width:68%;">
            <el-option :value="undefined" label="所有"></el-option>
            <el-option v-for="item in options" :key="item.user_id" :label="item.name" :value="item.user_id"></el-option>
          </el-select>
        </div>

        <div class="flex_box_center" v-if="isSales">
          &nbsp;&nbsp;<span>销售员&nbsp;&nbsp;</span>
          <el-select clearable v-model="query.salesId"  style="width:68%;">
            <el-option :value="undefined" label="所有"></el-option>
            <el-option v-for="(item,index) in salePersonList" :key="index" :label="item.description" :value="item.id"></el-option>
          </el-select>
        </div>
      </div>

      
      <div class="flex_wrap" v-if="isdel">
        <div class="flex_box_center">
          &nbsp;&nbsp;<span>营业点&nbsp;&nbsp;</span>
          <el-select clearable v-model="query.outletId" multiple style="width:68%" @change="changeOutletId">
            <el-option label="所有" :value="undefined"></el-option>
            <el-option v-for="item in outletsListArr" :key="item.id" :label="item.description" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="flex_box_center" v-if="isFood">
          &nbsp;&nbsp;<span>菜谱&nbsp;&nbsp;</span>
          <el-select clearable v-model="query.foodBookIds" multiple style="width:68%" @change="changeBookByOutlets">
            <el-option label="所有" :value="undefined"></el-option>
            <el-option v-for="item in bookByOutletsArr" :key="item.foodBookId" :label="item.description"
              :value="item.foodBookId">
            </el-option>
          </el-select>
        </div>
        <div class="flex_box_center" v-if="isFood">
          &nbsp;&nbsp;<span>菜类&nbsp;&nbsp;</span>
          <el-select clearable v-model="query.foodTypeIds" multiple style="width:68%" @change="changefoodTypeByBooks">
            <el-option label="所有" :value="undefined"></el-option>
            <el-option v-for="item in foodTypeByBooksArr" :key="item.foodTypeId" :label="item.description"
              :value="item.foodTypeId">
            </el-option>
          </el-select>
        </div>

        <div class="flex_box_center" v-if="isFood">
          <el-input v-model="query.queryLike" oninput="value=value.toUpperCase()" placeholder="请输入菜名/菜码进行筛选"
            @change="handleQueryLike"></el-input>
        </div>


      </div>
      <div style="margin:6px 10px;min-width:200px;text-align:right;font-size:14px">
        <el-button style="margin:6px 10px" size="small" @click="hanleQuery" type="primary">查询</el-button>
        <el-button type="primary"  size="small"  @click="handlePrint('print')">打印</el-button>
        <el-button type="primary"  size="small"  @click="handlePrint('preview')">打印预览</el-button>
        <el-button type="primary"  size="small"  v-if="isExport" @click="handleExport">导出</el-button>
      </div>
    </el-row>
  </el-card>
</template>

<script>
  
  import DateUtils from '@/utils/DateUtils';
  
  export default {
    props: {
      title: {
        type: String
      },
      data: {
        type: Object
      },
      isAll: {
        type: Boolean
      },
      isFood: {
        type: Boolean,
        default: false
      },
      isdel: {
        type: Boolean,
        default: true
      },
      isExport: {
        type: Boolean,
        default: true
      },
      isDay: {
        type: Boolean,
        default: true
      },
      isSales: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        options: [],
        salePersonList: [],
        query: {
          shiftCode: '',
          userId: '',
          outletId: [],
          foodBookIds: [],
          foodTypeIds: [],
          salesId: [],
          startTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd"),
          endTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd"),
        },
        pickerOptionsStart: {
          disabledDate: time => {
            let delay = this.query.endTime
            if (delay) {
              return time.getTime() > new Date(delay).getTime()
            }
          },
        },
        pickerOptionsEnd: {
          disabledDate: time => {
            let delay = this.query.startTime
            if (delay) {
              return time.getTime() < (new Date(delay).getTime() - 3600 * 1000 * 24)
            }
          },
        },
        queryShiftValue: '',
        queryParams: undefined,
        resetReport: false,
        newWindow: false,
        marketingEmployees: [],
        agreements: [],
        outletsListArr: [],
        bookByOutletsArr: [],
        foodTypeByBooksArr: [],
        interval: false,
        loadingButton: false

      }
    },
    created() {
      this.getEmpLists();
      if(this.isSales) {
        this.getSalesPersonList()
      }
    },
    methods: {

      handleShift(value) {

        this.$bus.$emit('renderQueryShiftValue', value);
      },
      getEmpLists() {
        //获取操作员工

        let url = this.api.getListMap,
          methods = "get"
        this.$axios({
          url,
          methods
        }).then(response => {
          if (response.data.status === 0) {
            this.options = response.data.data;
            console.log(this.options,'this.options')
          }
        });
        // 控制营业点
        url = this.api.getoutlets
        let data = {
          posCode: localStorage.getItem('posCode')
        }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          if (res.data.status === 0) {
            this.outletsListArr = res.data.data
          }
        })
        url = this.api.bookByOutlets
        this.$axios({
          url,
          methods
        }).then(res => {
          if (res.data.status === 0) {
            this.bookByOutletsArr = res.data.data
          }
        })

        url = this.api.foodTypeByBooks
        this.$axios({
          url,
          methods
        }).then(res => {
          if (res.data.status === 0) {
            this.foodTypeByBooksArr = res.data.data
          }
        })
      },
      //销售员
      getSalesPersonList() {
        let methods = 'get'
        let url = this.api.listByParam
        this.$axios({
          methods,
          url
        }).then(res => {
          console.log(res);
          this.salePersonList = res.data.data
          // this.salePersonObj.id = res.data.data[0].id
        })
      },
      changeOutletId(val) {
        console.log(11, val);
        let outletIds = val.join(",")
        let data={
          outletIds:val.join(",")
        }
        this.query.foodBookIds = []
        this.query.foodTypeIds = []
          url = this.api.bookByOutlets
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          if (res.data.status === 0) {
            this.bookByOutletsArr = res.data.data
          }
        })
      },
      changeBookByOutlets(val) {
        this.query.foodTypeIds = []
        let foodBookIds = val.join(",")
        let data ={
        foodTypeByBooks:val.join(',')

        }

          url = this.api.foodTypeByBooks
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          if (res.data.status === 0) {
            this.foodTypeByBooksArr = res.data.data
          }
        })
      },
      changefoodTypeByBooks(val) {

      },
      handleQueryLike(e) {
        this.query.queryLike = e;
      },
      hanleQuery() {
        this.$bus.$emit('todoQuery', this.query)
        this.$bus.$emit('outletsListArr', this.outletsListArr)
        this.$bus.$emit('options', this.options)
      },
      //打印
      handlePrint(type) {
        this.$bus.$emit('todoPrintCatering', type)
      },
      handleExport() {
        this.$bus.$emit('todoExportCatering')
      },

    }
  }
</script>

<style lang="scss" scoped>
  .el-card {
    width: 100%;

    .flex_wrap {
      flex-wrap: nowrap;
      margin-top: 10px;
    }
    .flex_box_center{
      font-size: 14px;
    }
  }
</style>